import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { StatusBadge } from './StatusBadge';
import { Order } from '../data/mockData';
interface OrderCardProps {
  order: Order;
}
export function OrderCard({
  order
}: OrderCardProps) {
  const navigate = useNavigate();
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-NG', {
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };
  const borderColors = {
    pending: 'border-l-[#FFBE0B]',
    processing: 'border-l-[#4CC9F0]',
    completed: 'border-l-[#00D68F]'
  };
  return <div onClick={() => navigate(`/orders/${order.id}`)} className={`glass-card glass-card-hover p-4 cursor-pointer border-l-2 ${borderColors[order.status]} group`} data-id="element-32">
      <div className="flex justify-between items-start mb-3" data-id="element-33">
        <div className="flex-1" data-id="element-34">
          <h3 className="text-white font-semibold tracking-tight" data-id="element-35">
            {order.productName}
          </h3>
          <p className="text-[#64748B] text-sm mt-1" data-id="element-36">
            Buyer: <span className="text-[#94A3B8]" data-id="element-37">{order.buyerName}</span>
          </p>
        </div>
        <StatusBadge status={order.status} size="sm" data-id="element-38" />
      </div>

      <div className="flex justify-between items-center pt-3 border-t border-white/[0.04]" data-id="element-39">
        <span className="text-white font-bold text-lg tracking-tight" data-id="element-40">
          ₦{order.amount.toLocaleString()}
        </span>
        <div className="flex items-center gap-2" data-id="element-41">
          <span className="text-[#64748B] text-xs font-medium" data-id="element-42">
            {formatDate(order.date)}
          </span>
          <ChevronRight className="w-4 h-4 text-white/20 group-hover:text-[#00D68F] transition-colors" data-id="element-43" />
        </div>
      </div>
    </div>;
}